export const DOCUMENTTYPE_DELETE_RESET = 'DOCUMENTTYPE_DELETE_RESET'
export const DOCUMENTTYPE_DELETE_SET_ERROR = 'DOCUMENTTYPE_DELETE_SET_ERROR'
export const DOCUMENTTYPE_DELETE_SET_DELETED = 'DOCUMENTTYPE_DELETE_SET_DELETED'
export const DOCUMENTTYPE_DELETE_TOGGLE_LOADING = 'DOCUMENTTYPE_DELETE_TOGGLE_LOADING'
